module.exports = function (app) {
	'use strict';

	app.controller('pages.assistEmployees.changePcp', ['$scope','$state', 'sessionData', 'employee', 'provider', 'storage', 'employerUtility', 'services', 'planAdmin',
		function ($scope, $state, sessionData, employee, provider, storage, employerUtility, services, planAdmin) {
			$scope.employee = employee;
			$scope.provider = provider;
			$scope.employee.failed = false;
			$scope.provider.failed = false;

			$scope.sidebar = {
				breadCrumb : {
					primary : {
						title: "Assist Employees",
						state: "assistEmployees"
					},
					secondary : {
						title: "Change PCP"
					} } };

			$scope.feedback = {};

			// WE STORE A FEW CRITICAL ITEMS SO THAT WE CAN ACCESS THEM WHEN WE COME BACK FROM Search Provider Directory
			if($state.params.groupNumber && $state.params.umi){
				$scope.group = $state.params.groupNumber;
				$scope.umi = $state.params.umi;
				storage.set('thisGroup', $state.params.groupNumber);
				storage.set('thisUmi', $state.params.umi);
				storage.set('isIbcAhpa', sessionData.isIbcAhpa);
			}
			// HERE IS WHERE WE HANDLE COMING BACK FROM THE Search Provider Directory page
			if(!$state.params.groupNumber && !$state.params.umi && storage.get('thisGroup')){
				$scope.group = storage.get('thisGroup');
				$scope.umi = storage.get('thisUmi');
				sessionData.isIbcAhpa = storage.get('isIbcAhpa');
			}
			if(!$state.params.groupNumber && !$state.params.umi && !storage.get('thisGroup')){
				$state.go('assistEmployees');
				return;
			}
			// get the group name to make Search Directory work
			$scope.strGroupName = '';
			$scope.showChgPcpCopyToOthers = false;

			$scope.editPermission = planAdmin.canModifyGroupNumber($scope.group); // for some reason $scope.group is groupNumber in this file

			$scope.basicInfo = sessionData.basicInfo;
			sessionData.theEmployee = null;
			sessionData.theProvider = null;
			employee.loadSummary($scope.umi).then(
				function(employee) {
					sessionData.theEmployee = employee;
					provider.load(employee, $scope.group).then(
						function(provider) {
							if (!provider.data) {
								return;
							}
							sessionData.theProvider = provider;
							employerUtility.normalizeParticipantsData($scope)

							// here we get the group name that we need if Search Provider Directory is clicked
							if ((sessionData.employerInfo.brandName != '6008') && (sessionData.employerInfo.brandName != '6009')) {
								services.rbsmbl.getGroupName().fetch($scope.group).then(function (response) {
									var strGroupName;
									if (response.data && response.data.payload.providerDataList && response.data.payload.providerDataList.providerDataRecord
										&& response.data.payload.providerDataList.providerDataRecord[0] && response.data.payload.providerDataList.providerDataRecord[0].productName) {
										strGroupName = response.data.payload.providerDataList.providerDataRecord["0"].productName
									}
									sessionData.strGroupName = strGroupName;
								});
							}
						}
					);
				}
			);
		}
	]);
};
